import React from 'react';

function EmployerView() {
  // TODO: 从 URL token 获取学员信息
  
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="card">
          <h1 className="text-2xl font-bold mb-6">Student Progress Inquiry</h1>
          
          <div className="bg-blue-50 p-4 rounded-lg mb-6">
            <p className="text-sm text-blue-900">
              ⚠️ This page is for employer use only. To query student progress, please contact the driving school office for an access link.
            </p>
          </div>

          <div className="text-center py-12 text-gray-500">
            <p>Feature Coming Soon...</p>
            <p className="text-sm mt-2">Will display student learning progress, hours statistics, exam records, etc.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmployerView;
